/*
 * Zeile "Sicherheitshinweise und Herstellerangaben" in der Kaufbox (blocks/zw-sicherheit.liquid,
 * Schritt 9.1, O-59)
 *
 * Klick auf den Link: oeffnet im Aufklapper unter der Kaufbox (blocks/zw-produktinfo.liquid) die
 * Zeilen "Herstellerangaben" und "Warnhinweise" (details[data-zw-zeile="hersteller"] und
 * "warnhinweise"), scrollt zur ersten davon und setzt den Fokus auf deren Ueberschrift. Fehlen
 * beide Zeilen, bleibt es beim normalen Ankersprung zum Aufklapper - genau wie ohne dieses Skript.
 *
 * Kein Sprungziel (Befund H4): Fehlt der Aufklapper auf der Seite ganz (im Editor aus, nicht
 * eingesetzt, oder der Block steht in einer anderen Section), fuehrt der Link zur Produktseite -
 * mit demselben Anker, dort springt der Browser selbst hin. Steht man schon auf dieser
 * Produktseite, wuerde Neuladen nichts aendern; dann bleibt es beim normalen Ankersprung.
 *
 * Nachkorrektur (Befund S1): Bei klebender Kaufbox am Desktop (sticky_details_desktop) verschiebt
 * sich das Ziel, waehrend der Browser weich scrollt - der Sprung kann zu tief landen. Nach dem
 * Scrollen wird deshalb einmal nachgemessen: Steht die Zeile dann nicht im oberen Drittel des
 * Fensters (unterhalb des mitlaufenden Kopfbereichs), wird ein zweites Mal gesprungen. Das Ende
 * des Scrollens meldet das Ereignis "scrollend"; Browser ohne dieses Ereignis warten ~600 ms und
 * danach, bis 150 ms lang kein Scroll-Ereignis mehr kam (hoechstens 3 s). Bei "Bewegung
 * reduzieren" springen beide Schritte ohne Animation.
 * Wer scrollt: Ab 990 px scrollt in Horizon nicht das Dokument, sondern der Rahmen .page-wrapper
 * (base.css: html mit overflow hidden) - dessen scroll/scrollend-Ereignisse erreichen das Dokument
 * nicht. Deshalb horcht das Skript am naechsten tatsaechlich scrollbaren Vorfahren der Zeile
 * (scrollQuelle), ohne Horizons Klassennamen fest einzubauen; gibt es keinen, am Dokument.
 *
 * Warum das Oeffnen haelt: Horizons <accordion-custom> (assets/accordion-custom.js) setzt den
 * offenen Zustand nur beim Einhaengen und beim Wechsel zwischen Handy- und Desktop-Breite neu
 * (#setDefaultOpenState). Ein Klick danach wird nicht zurueckgesetzt. Abhaengig von Horizons
 * Namen accordion-custom und dieser Methode - beim Horizon-Update pruefen (STATUS.md Abschnitt 4).
 *
 * Ein Listener am Dokument statt am Link: Baut Horizon die Kaufbox neu auf (etwa beim
 * Variantenwechsel), bleibt er trotzdem gueltig. Im Schnellkauf-Dialog ist der Link
 * ausgeblendet, dort gibt es nichts zu tun.
 */
const ZEILEN = ['hersteller', 'warnhinweise'];
const MINDESTWARTEZEIT = 600;
const RUHEZEIT = 150;
const HOECHSTWARTEZEIT = 3000;

/**
 * Naechster Vorfahre, der tatsaechlich scrollt (overflow auto/scroll und hoeher als sichtbar),
 * sonst das Dokument.
 * @param {Element} element
 * @returns {Element | Document}
 */
function scrollQuelle(element) {
  for (let knoten = element.parentElement; knoten && knoten !== document.documentElement; knoten = knoten.parentElement) {
    const { overflowY } = getComputedStyle(knoten);
    if ((overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && knoten.scrollHeight > knoten.clientHeight + 1) {
      return knoten;
    }
  }
  return document;
}

/**
 * Ruft weiter() einmal auf, sobald das Scrollen vorbei ist.
 * @param {Element | Document} quelle - das Element, das scrollt (oder das Dokument)
 * @param {() => void} weiter
 */
function nachScrollende(quelle, weiter) {
  const beginn = performance.now();
  let letzteBewegung = beginn;
  let fertig = false;

  const merken = () => {
    letzteBewegung = performance.now();
  };

  const abschliessen = () => {
    if (fertig) return;
    fertig = true;
    quelle.removeEventListener('scroll', merken);
    quelle.removeEventListener('scrollend', abschliessen);
    weiter();
  };

  const nachsehen = () => {
    if (fertig) return;
    const jetzt = performance.now();
    if (jetzt - letzteBewegung < RUHEZEIT && jetzt - beginn < HOECHSTWARTEZEIT) {
      window.setTimeout(nachsehen, RUHEZEIT);
      return;
    }
    abschliessen();
  };

  quelle.addEventListener('scroll', merken, { passive: true });
  if ('onscrollend' in window) quelle.addEventListener('scrollend', abschliessen);
  window.setTimeout(nachsehen, MINDESTWARTEZEIT);
}

/**
 * Steht die Zeile im oberen Drittel des Fensters und nicht unter dem Kopfbereich?
 * Die Obergrenze ist ihr scroll-margin (Kopfhoehe + 16 px, assets/zwergenwald-marke.css).
 * @param {Element} zeile
 */
function stehtOben(zeile) {
  const oben = zeile.getBoundingClientRect().top;
  const abstand = parseFloat(getComputedStyle(zeile).scrollMarginBlockStart) || 0;
  return oben >= abstand - 4 && oben <= window.innerHeight / 3;
}

/**
 * @param {HTMLAnchorElement} link
 * @param {string} zielId
 * @returns {boolean} true, wenn zur Produktseite gewechselt wird
 */
function zurProduktseite(link, zielId) {
  const adresse = link.dataset.zwProduktUrl;
  if (!adresse) return false;

  const ziel = new URL(adresse, window.location.href);
  if (ziel.pathname === window.location.pathname) return false;
  if (zielId) ziel.hash = zielId;
  window.location.assign(ziel.href);
  return true;
}

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest('a[data-zw-sicherheit-link]');
  if (!(link instanceof HTMLAnchorElement)) return;

  const zielId = decodeURIComponent(link.hash.replace(/^#/, ''));
  const ziel = zielId ? document.getElementById(zielId) : null;
  if (!ziel) {
    if (zurProduktseite(link, zielId)) event.preventDefault();
    return;
  }

  const zeilen = ZEILEN.map((name) => ziel.querySelector(`details[data-zw-zeile="${name}"]`)).filter(
    (zeile) => zeile instanceof HTMLDetailsElement
  );
  if (zeilen.length === 0) return;

  event.preventDefault();
  for (const zeile of zeilen) zeile.open = true;

  const erste = zeilen[0];
  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const verhalten = ruhig ? 'instant' : 'smooth';
  const quelle = scrollQuelle(erste);
  erste.scrollIntoView({ behavior: verhalten, block: 'start' });
  erste.querySelector('summary')?.focus({ preventScroll: true });

  nachScrollende(quelle, () => {
    if (!erste.isConnected || stehtOben(erste)) return;
    erste.scrollIntoView({ behavior: verhalten, block: 'start' });
  });
});
